import { injectable } from 'inversify';
import { makeAutoObservable } from 'mobx';

import { USER_PROFILE_KEY } from '@libs/constants';
import { UserInfo } from '@libs/types';

import { LocalStorageStore } from './LocalStorageStore';

export const authTokenKey = 'auth.token';
export const refreshTokenKey = 'auth.refreshToken';

@injectable()
export class AuthStore {
  private readonly tokenKey = authTokenKey;
  private readonly refreshKey = refreshTokenKey;

  public isLoading = true;
  public token: string | null = null;
  public refreshToken: string | null = null;
  public userProfile: UserInfo | null = null;

  constructor(private readonly localStorageStore: LocalStorageStore) {
    makeAutoObservable(this);

    this.token = this.localStorageStore.authToken;
    this.refreshToken = this.localStorageStore.refreshToken;
    this.userProfile = this.localStorageStore.userProfile;
    this.isLoading = false;
  }

  get isLoggedIn(): boolean {
    return Boolean(this.token);
  }

  setToken(token: string | null): void {
    this.token = token;
    if (token) {
      this.localStorageStore.set(this.tokenKey, token);
    } else {
      this.localStorageStore.remove(this.tokenKey);
    }
  }

  setRefreshToken(token: string | null): void {
    this.refreshToken = token;
    if (token) {
      this.localStorageStore.set(this.refreshKey, token);
    } else {
      this.localStorageStore.remove(this.refreshKey);
    }
  }

  setUserProfile(profile: UserInfo | null): void {
    this.userProfile = profile;
    if (profile) {
      this.localStorageStore.set(USER_PROFILE_KEY, profile);
    } else {
      this.localStorageStore.remove(USER_PROFILE_KEY);
    }
  }

  clearAuth(): void {
    this.setToken(null);
    this.setRefreshToken(null);
    this.setUserProfile(null);
  }
}
